// Centralized premium imagery (Unsplash, curated for a dark fintech/legal aesthetic).

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1531819177115-428566ccfb50?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  trust:
    "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  officeMeeting:
    "https://images.unsplash.com/photo-1637979910474-38e3ad8d5cab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  banking:
    "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  accounting:
    "https://images.unsplash.com/photo-1707157284454-553ef0a4ed0d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

const U = (id) => `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600`;
const IMG = {
  ny: U("1496588152823-86ff7695e68f"),
  london: U("1601412928796-71c3a10c31a2"),
  singapore: U("1544214036-5aaeb9e32d11"),
  hongkong: U("1594973782943-3314fe063f68"),
  dubai: U("1512453979798-5ea266f8880c"),
  zurich: U("1747081207735-35fa43fd7a1e"),
  cyprus: U("1769549288622-4aa3f428ba0d"),
  panama: U("1598041543955-0d88c390f3b5"),
  mauritius: U("1513415277900-a62401e19be4"),
  dublin: U("1664887193400-d135058c287a"),
  caribbean: U("1483683804023-6ccdb62f86ef"),
  bangkok: U("1639379090837-309066ebbe2f"),
  sydney: U("1687443105981-69e550f59fea"),
};

const COUNTRY_IMAGES = {
  unitedstates: IMG.ny, unitedkingdom: IMG.london, singapore: IMG.singapore, hongkong: IMG.hongkong,
  uaerak: IMG.dubai, switzerland: IMG.zurich, luxembourg: IMG.zurich, cyprus: IMG.cyprus, malta: IMG.cyprus,
  gibraltar: IMG.cyprus, panama: IMG.panama, costarica: IMG.panama, mauritius: IMG.mauritius, ireland: IMG.dublin,
  isleofman: IMG.dublin, thailand: IMG.bangkok, labuan: IMG.bangkok, australia: IMG.sydney,
  seychelles: IMG.mauritius, belize: IMG.caribbean, saintvincent: IMG.caribbean, britishvirginislands: IMG.caribbean,
  anguilla: IMG.caribbean, samoa: IMG.caribbean, cayman: IMG.caribbean, saintlucia: IMG.caribbean,
  bahamas: IMG.caribbean, nevis: IMG.caribbean, cookislands: IMG.caribbean,
};

export function countryImage(slug) {
  return COUNTRY_IMAGES[slug] || IMAGES.hero;
}

export function bankImage(type) {
  return type === "Digital" ? IMAGES.accounting : IMAGES.banking;
}

export const JURISDICTION_CARDS = [
  {
    name: "United States",
    detail: "Delaware · Wyoming",
    img: "https://images.unsplash.com/photo-1496588152823-86ff7695e68f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    name: "United Kingdom",
    detail: "London",
    img: "https://images.unsplash.com/photo-1601412928796-71c3a10c31a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    name: "Singapore",
    detail: "Marina Bay",
    img: "https://images.unsplash.com/photo-1544214036-5aaeb9e32d11?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    name: "Hong Kong",
    detail: "Victoria Harbour",
    img: "https://images.unsplash.com/photo-1594973782943-3314fe063f68?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    name: "UAE",
    detail: "Dubai Free Zones",
    img: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    name: "Offshore",
    detail: "BVI · Cayman",
    img: "https://images.unsplash.com/photo-1761493826870-b3a05338e4aa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
];
